import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSchemaViewerDateCalcContinuous = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={17}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#47a67f",
      }}
      d="M16 4h-2V3h-1v1h-2V3h-1v1H8c-.5 0-1 .5-1 1v7c0 .5.5 1 1 1h8c.5 0 1-.5 1-1V5c0-.5-.5-1-1-1zm0 8H8V8h8v4zm0-5H8V5h2v1h1V5h2v1h1V5h2v2zM3 9h3v1H3zM3 7h3v1H3z"
    />
  </svg>
);
const Memo = memo(SvgSchemaViewerDateCalcContinuous);
export default Memo;
